import * as React from "react";
import { Sparkles } from "lucide-react";
import { cn } from "@/lib/utils";

export interface NewBadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  /** Label to show; default "New". Use for i18n. */
  children?: React.ReactNode;
}

/**
 * Reusable "New" badge with icon, accent color, and shine animation. Use for new features or highlights.
 */
function NewBadge({ className, children = "New", ...props }: NewBadgeProps) {
  return (
    <span
      className={cn(
        "new-badge relative inline-flex shrink-0 items-center gap-1.5 overflow-hidden rounded-full border-2 border-brand-spring/50 bg-brand-spring/20 px-3 py-1.5 text-sm font-semibold text-text-1 transition-colors focus:outline-none focus:ring-2 focus:ring-brand-spring/40 focus:ring-offset-2 dark:border-brand-spring/60 dark:bg-brand-spring/25",
        className
      )}
      {...props}
    >
      <Sparkles className="relative z-10 size-4 shrink-0 text-brand-spring" aria-hidden />
      <span className="relative z-10">{children}</span>
      <span className="new-badge-shine" aria-hidden />
    </span>
  );
}

export { NewBadge };
